import { client } from '@api/client';

import { IAlarmManagement, IAlarmOran, IAlarmsFlexidas } from '@interfaces/alarms/alarm';
import {
	IAlarmCreateNoVeRuleDTO,
	IGetAlarmDTO,
	IGetAlarmManagementFlexidasDTO,
	TAlarmUpdateNoVeRuleDTO,
} from '@interfaces/alarms/dto/alarmsDTO';
import { IId, TIdName, TNameTitle } from '@interfaces/common/common';
import { IExportDefaultDTO } from '@interfaces/common/defaultDTO';
import { IItemsResponse } from '@interfaces/common/response';

import { TVendorsValues } from '@enums/common';

import { URL } from './urls';

const {
	alarmManagementTable,
	alarmsVendors,
	alarmManagementTableFlexidas,
	alarmManagementTableOran,
	alarmManagementNoVesNetworkElements,
	alarmManagementAddNoVesRule,
	alarmManagementNoVesEvent,
} = URL;

export const getAlarm = ({
	pageSize,
	page,
	sortDirection,
	sortFieldName,
	searchValue,
	isActive,
	group,
	severity,
}: IGetAlarmDTO): Promise<IItemsResponse<IAlarmManagement>> => {
	return client.get(alarmManagementTable, {
		params: {
			pageSize,
			page,
			sortDirection,
			sortFieldName,
			searchValue,
			isEnabled: isActive,
			group,
			severity,
		},
	});
};

export const getAlarmOran = ({ id }: IId): Promise<IAlarmOran> => {
	return client.get(`${alarmManagementTableOran}/${id}`);
};

export const getAlarmsOran = (
	data: IGetAlarmManagementFlexidasDTO,
): Promise<IItemsResponse<IAlarmOran>> => {
	return client.get(alarmManagementTableOran, {
		params: data,
	});
};

export const getAlarmsFlexidas = (
	data: IGetAlarmManagementFlexidasDTO,
): Promise<IItemsResponse<IAlarmsFlexidas>> => {
	return client.get(alarmManagementTableFlexidas, {
		params: data,
	});
};

export const getAlarmsVendors = (): Promise<TNameTitle<TVendorsValues>[]> => {
	return client.get(alarmsVendors);
};

export const getAlarmsNoVesNetworkElements = (): Promise<TIdName[]> => {
	return client.get(alarmManagementNoVesNetworkElements);
};

export const exportAlarmManagementOran = (dto: IExportDefaultDTO): Promise<void> => {
	return client.post(`${alarmManagementTableOran}/export`, dto);
};

export const createAlarmNoVesRule = (dto: IAlarmCreateNoVeRuleDTO): Promise<void> => {
	return client.post(alarmManagementAddNoVesRule, dto);
};

export const createAlarmNoVesRules = (dto: IAlarmCreateNoVeRuleDTO[]): Promise<PromiseSettledResult<void>[]> => {
	return Promise.allSettled(dto.map((item) => createAlarmNoVesRule(item)));
};

export const updateAlarmNoVesRule = ({ id, ...dto }: TAlarmUpdateNoVeRuleDTO): Promise<void> => {
	return client.put(`${alarmManagementNoVesEvent}${id}/update-rule`, dto);
};

export const updateAlarmNoVesRules = (dto: TAlarmUpdateNoVeRuleDTO[]): Promise<PromiseSettledResult<void>[]> => {
	return Promise.allSettled(dto.map((item) => updateAlarmNoVesRule(item)));
};

export const deleteAlarmNoVesRule = ({ id }: IId): Promise<void> => {
	return client.delete(`${alarmManagementNoVesEvent}${id}/delete-rule`);
};

export const deleteAlarmNoVesRules = (dto: IId[]): Promise<PromiseSettledResult<void>[]> => {
	return Promise.allSettled(dto.map((item) => deleteAlarmNoVesRule(item)));
};

